import { isString, isObject, isArray, isEmpty } from 'lodash';


const hasDataAttr = (ref) => Boolean(ref && (ref.current && !isEmpty(ref.current.dataset) || (!isEmpty(ref.dataset))));
const getAllDataAttr = (ref) => hasDataAttr(ref) ? (ref.current? { ...ref.current.dataset } : { ...ref.dataset }) : {};

/*
    create an object called "objName" with all data attributes
    found in <ref> react node
    allow inline entries injection by {inlineEntry}
    returns object
*/
const createParsedObject = (objName, ref, inlineEntry) => {
    if (!hasDataAttr(ref) || !isString(objName)) {
        return {};
    }
    const newObj = {};
    newObj[objName] = {};
    Object.assign(newObj[objName], getAllDataAttr(ref));
    if (!isEmpty(inlineEntry) && isObject(inlineEntry)) {
        Object.assign(newObj[objName], inlineEntry);
    }
    return newObj;
};

/*
    check if the object {data} contains all mentioned [keys]
    returns boolean
*/
const hasFilters = (data, keys) =>
    Boolean(!isEmpty(data) && isObject(data)
    && !isEmpty(keys) && isArray(keys)
    && keys.every((prop) => Object.prototype.hasOwnProperty.call(data, prop)));

/*
    check if the object {data} contains one of the mentioned [keys]
    returns boolean
*/
const hasAnyFilter = (data, keys) =>
    Boolean(!isEmpty(data) && isObject(data)
    && !isEmpty(keys) && isArray(keys)
    && keys.find((prop) => Object.prototype.hasOwnProperty.call(data, prop)));


export const DataAttributesUtils = {
    hasDataAttr,
    getAllDataAttr,
    createParsedObject,
    hasFilters,
    hasAnyFilter,
};
